// material
import { gql, useLazyQuery, useMutation } from "@apollo/client";
import {
  Check,
  Close,
  CloseOutlined,
  Done,
  Download,
  Edit,
  RestartAlt,
  Search,
} from "@mui/icons-material";
import {
  Button,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  InputAdornment,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import {
  DataGridPremium,
  gridFilteredSortedRowEntriesSelector,
  GridFilterModel,
  useGridApiRef,
} from "@mui/x-data-grid-premium";
import { useContext, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { ProjectContext } from "src/utils/contexts/project";
import { useSearchParamsState } from "src/utils/useSearchParamsState";
import { PersonContext } from "src/utils/contexts/person";
import { decodeFromBase64 } from "pdf-lib";
import { genPDFDownload } from "src/pages/Inspections/MyInspections/routes/InspectionWebView/downloadReport";
import checkboxColumn from "src/pages/Inspections/Create/CheckboxColumn";
import { generateReports } from "src/pages/Reporting/GenerateReports";
import { useSnackbar } from "notistack";

// ----------------------------------------------------------------------
const GET_PROJECT_PROJECTS = gql`
  query ProjectProjects($project: InputProjectParams!) {
    projectProjects(project: $project) {
      id
    }
  }
`;

const GET_PROJECT_INSPECTIONS_FOR_REVIEW = gql`
  query projectsInspectionsForReview($projectIds: [ID], $personId: ID!) {
    projectsInspectionsForReview(projectIds: $projectIds, personId: $personId) {
      projectId
      id
      number
      location {
        street1
        street2
        zip
        id
        unit
        name
        state
        city
      }
      inspectionAssignments {
        start
        end
        person {
          firstName
          lastName
        }
        status
        statusDate
        id
        hasReportsGenerated
      }
      inspectionType {
        name
      }
      status
    }
  }
`;

const GET_INSPECTION_ASSIGNMENT_STATUS_VALUES = gql`
  query inspectionAssignmentStatusValues {
    inspectionAssignmentStatusValues {
      status
    }
  }
`;

const GET_INSPECTION_ASSIGNMENT_REPORTS = gql`
  query GetInspectionAssignmentReportResults(
    $reportResult: InputReportResultParams!
  ) {
    reportResults(reportResult: $reportResult) {
      id
      reportTypeTemplateId
      inspectionId
      inspectionAssignmentId
      thoFormInstanceId
      documentUrl
      documentId
      documentBytes
      requestedBy
      fileName
      fileExtension
    }
  }
`;

const UPLOAD_REPORT_GENERATION_REQUEST = gql`
  mutation UploadReportGenerationRequest(
    $reportGenerationRequest: InputReportGenerationRequestParams!
  ) {
    uploadReportGenerationRequest(
      reportGenerationRequest: $reportGenerationRequest
    ) {
      id
      inspectionAssignmentId
    }
  }
`;

const REPORT_GENERATION_REQUESTS = gql`
  query ReportGenerationRequests(
    $reportGenerationRequest: InputReportGenerationRequestParams!
  ) {
    reportGenerationRequests(
      reportGenerationRequest: $reportGenerationRequest
    ) {
      id
      metadata
      personId
      jobId
      jobStatus
      inspectionId
      inspectionAssignmentId
      thoFormInstanceId
      thoFormId
      destinationReportResultIds
    }
  }
`;

const APPROVE_REPORTS = gql`
  mutation ApproveReports($reportApproval: InputReportApprovalParams) {
    approveReports(reportApproval: $reportApproval) {
      result
    }
  }
`;

export default function InspectionAssignments() {
  const person = useContext(PersonContext);
  const project: any = useContext(ProjectContext);
  const [dataLoading, setDataLoading] = useState(true);
  const [refetching, setRefetching] = useState(false);
  const [projectProjects, setProjectProjects] = useState<any[]>([]);
  const [inspections, setProjectInspections] = useState<any[]>([]);
  const [getProjectProjects] = useLazyQuery(GET_PROJECT_PROJECTS, {
    fetchPolicy: "network-only",
    onCompleted: (response) => {
      setProjectProjects(response.projectProjects);
      setProjectProjects(response.projectProjects);
    },
    onError: (response) => {},
  });
  const [getProjectInspectionsForReview, { refetch }] = useLazyQuery(
    GET_PROJECT_INSPECTIONS_FOR_REVIEW,
    {
      fetchPolicy: "network-only",
      onCompleted: (response) => {
        let filtered = response.projectsInspectionsForReview.filter(
          (item: any) => {
            return item.id != null;
          }
        );

        setProjectInspections(filtered);
        if (response.projectsInspectionsForReview) {
          setDataLoading(false);
        }
        setRefetching(false);
      },
      onError: (response) => {},
    }
  );
  function handleRefetching() {
    setRefetching(true);
    refetch().then((result) => {
      setRefetching(false);
      let filtered = result.data.projectsInspectionsForReview.filter(
        (item: any) => {
          return item.id != null;
        }
      );

      setProjectInspections(filtered);
      if (result.data.projectsInspectionsForReview) {
        setDataLoading(false);
      }
    });
  }
  const [getInspectionAssignmentStatusValues, { data: statusValues }] =
    useLazyQuery(GET_INSPECTION_ASSIGNMENT_STATUS_VALUES, {
      fetchPolicy: "network-only",
      onCompleted: (response) => {},
      onError: (response) => {},
    });

  useEffect(() => {}, [inspections, refetching]);
  useEffect(() => {
    if (dataLoading) {
      let myProject = project.project;
      async function getData() {
        if (myProject) {
          // await getProjectProjects({
          //   variables: {
          //     project: {
          //       id: myProject.id,
          //       name: myProject.name,
          //       projectNumber: myProject.projectNumber,
          //     },
          //   },
          // });
          await getProjectProjects({
            variables: {
              project: {
                id: myProject.id,
                name: myProject.name,
                projectNumber: myProject.projectNumber,
              },
            },
          });
          await getInspectionAssignmentStatusValues();
        }
        if (myProject && projectProjects.length > 0) {
          // await getProjectInspections({
          //   variables: {
          //     projectIds: projectProjects.map((e) => {
          //       return { projectId: e.id };
          //     }),
          //   },
          // });
          let myperson: any = person;
          await getProjectInspectionsForReview({
            variables: {
              projectIds: projectProjects.map((e) => {
                return e.id;
              }),
              personId: myperson.person.id,
            },
          });
        }
      }
      let timer = setTimeout(() => {
        getData();
      }, 500);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [
    project,
    dataLoading,
    getProjectInspectionsForReview,
    getProjectProjects,
    projectProjects,
  ]);

  useEffect(() => {
    setDataLoading(true);
  }, [project]);

  useEffect(() => {}, [statusValues]);

  function hasInspections() {
    if (inspections) {
      if (inspections.length > 0) {
        return true;
      }
    }
    return false;
  }

  return (
    //<Page title="Review | FINBACK670">
    <Container maxWidth="xl">
      <Stack direction="row" sx={{ pb: 5 }} spacing={2} alignItems="center">
        <Typography variant="h4">Review</Typography>
      </Stack>

      {!dataLoading && inspections && (
        <>
          <InspectionsTable
            inspections={inspections}
            loading={dataLoading}
            statusValues={statusValues}
            refetch={handleRefetching}
            refetching={refetching}
          />
        </>
      )}
      {dataLoading && !inspections.length && <CircularProgress />}
    </Container>
    // </Page>
  );
}

function NoRowsOverlay() {
  return (
    <Stack height="100px" alignItems="center" justifyContent="center">
      No inspection assignments to review.
    </Stack>
  );
}

const InspectionsTable = ({
  inspections,
  loading,
  statusValues,
  refetch,
  refetching,
}: {
  inspections: any;
  loading: boolean;
  statusValues: any;
  refetch: any;
  refetching: any;
}) => {
  const person: any = useContext(PersonContext);
  const apiRef = useGridApiRef();
  const [search, setSearch] = useState("");
  const [inspectionsWithMostRecent, setInspectionsWithMostRecent] =
    useState<any>();
  const [rowGroupingEncoded, setRowGroupingEncoded] = useSearchParamsState(
    "group",
    ""
  );
  const [downloadingReports, setDownloadingReports] = useState(false);
  const [generateReportsWarning, setGeneratingReportsWarning] = useState(false);
  const [generatingReports, setGeneratingReports] = useState(false);
  const [approvingReports, setApprovingReports] = useState(false);
  const [selected, setSelected] = useState<any[]>([]);
  const [reportGenerationRequestsToWatch, setReportGenerationRequestsToWatch] =
    useState<any[] | null>(null);

  const funRef = useRef<any>(null);

  const { enqueueSnackbar } = useSnackbar();
  const snackbar = (message: any, variant: any) => {
    // variant could be success, error, warning, info, or default
    enqueueSnackbar(message, { variant });
  };

  const rowGrouping = rowGroupingEncoded
    ? decodeURI(rowGroupingEncoded).split("^%")
    : [];
  const setRowGrouping = (groupArray: string[]) =>
    setRowGroupingEncoded(encodeURI(groupArray.join("^%")));

  const [filters, setFilters] = useState({ items: [] } as GridFilterModel);

  const [uploadReportGenerationRequest] = useMutation(
    UPLOAD_REPORT_GENERATION_REQUEST,
    {
      fetchPolicy: "network-only",
      onCompleted: (response) => {},
    }
  );

  const [getReportGenerationRequests] = useLazyQuery(
    REPORT_GENERATION_REQUESTS,
    {
      fetchPolicy: "network-only",
      onCompleted: (response) => {
        if (response.reportGenerationRequests) {
          var requests = response.reportGenerationRequests;
          if (requests.length > 0) {
            var request = requests[0];
            if (request.jobStatus === "completed") {
              setGeneratingReports(false);
              setReportGenerationRequestsToWatch(null);
              snackbar("Reports Generated", "success");
              debugger;
              refetch();
            }
          }
        }
      },
    }
  );

  const [
    getReportResults,
    { data: reportResultData, loading: reportResultDataLoading },
  ] = useLazyQuery(GET_INSPECTION_ASSIGNMENT_REPORTS, {
    fetchPolicy: "network-only",
    onCompleted: (result: any) => {},
  });

  const [approveReports] = useMutation(APPROVE_REPORTS, {
    onCompleted: (result) => {
      setApprovingReports(false);
      snackbar("Reports Approved", "success");
      refetch();
    },
  });

  useEffect(() => {}, [
    filters,
    downloadingReports,
    approvingReports,
    generatingReports,
    refetching,
    generateReportsWarning,
  ]);

  useEffect(() => {
    let newInspections: any[] = [];
    inspections.forEach((inspection: any, i: number) => {
      // let washoutCount = 0;
      // for (const key in washouts) {
      //   if (charBin2dec(key) === i) {
      //     washoutCount = washouts[key].length;
      //   }
      // }
      if (inspection.inspectionAssignments) {
        if (inspection.inspectionAssignments.length > 0) {
          let mostRecent = inspection.inspectionAssignments.reduce(
            (prev: any, current: any) =>
              prev.start > current.start ? prev : current
          );
          let person: any = mostRecent.person;

          newInspections.push({
            ...inspection,
            // washoutCount: washoutCount || 0,
            person: person ? person.firstName + " " + person.lastName : "---",
            start: mostRecent.start ?? null,
            end: mostRecent.end ?? null,
            hasReportsGenerated: mostRecent.hasReportsGenerated,
            statusDate: mostRecent.statusDate,
            type: inspection.inspectionType.name,
          });
        } else {
          newInspections.push({
            ...inspection,
            washoutCount: 0,
            person: "---",
            start: null,
            end: null,
            hasReportsGenerated: false,
            statusDate: null,
            type: inspection.inspectionType.name,
          });
        }
      } else {
        if (!inspection.inspectionType)
          newInspections.push({
            ...inspection,
            washoutCount: 0,
            person: "---",
            start: null,
            end: null,
            type: inspection.inspectionType.name,
          });
      }
    });
    setInspectionsWithMostRecent(newInspections);
  }, [inspections]);

  useEffect(() => {
    if (generatingReports && reportGenerationRequestsToWatch) {
      funRef.current = setInterval(() => {
        getReportGenerationRequests({
          variables: {
            reportGenerationRequest: {
              id: reportGenerationRequestsToWatch,
            },
          },
        });
      }, 5000);
      return () => {
        clearInterval(funRef.current);
      };
    }
  }, [generatingReports, reportGenerationRequestsToWatch]);

  const handleSelection = (ids: any) => {
    let selectedIDs = new Set(ids);
    let idsArray: any = Array.from(selectedIDs);
    setSelected(idsArray);
  };

  function handleGenerateReports() {
    setGeneratingReports(true);
    let inspections = inspectionsWithMostRecent.filter((i: any) => {
      return selected.indexOf(i.id) >= 0;
    });

    var requestsToWatch: any = [];
    var inspectionCount = 0;
    inspections.forEach((i: any) => {
      var reportGenerationRequest = {
        inspectionId: i.id,
        inspectionAssignmentId: i.inspectionAssignments[0].id,
        personId: person.person.id,
        jobStatus: "executing",
      };
      uploadReportGenerationRequest({
        variables: {
          reportGenerationRequest: reportGenerationRequest,
        },
      }).then((result) => {
        inspectionCount++;
        let resultId = result.data.uploadReportGenerationRequest.id;
        requestsToWatch.push(resultId);

        generateReports(
          result.data.uploadReportGenerationRequest.inspectionAssignmentId,
          person.person,
          resultId
        );
        if (inspectionCount === inspections.length) {
          setReportGenerationRequestsToWatch(requestsToWatch);
        }
      });
    });
  }

  const controlGroup = ["number", "type"];
  const controlGroupingApplied =
    JSON.stringify(rowGrouping) === JSON.stringify(controlGroup);

  const rowsWithTextboxFilter =
    search && inspectionsWithMostRecent
      ? inspectionsWithMostRecent.filter((inspection: any) => {
          return (
            inspection.number &&
            inspection.number.toUpperCase().includes(search.toUpperCase())
          );
        })
      : inspectionsWithMostRecent;

  return inspectionsWithMostRecent ? (
    <>
      <Stack
        width={"100%"}
        direction="row"
        justifyContent="space-between"
        marginBottom={2}
      >
        <Stack direction="row" justifyContent="center" spacing={2}>
          <Button
            size="small"
            variant={controlGroupingApplied ? "contained" : "outlined"}
            sx={{ borderRadius: 100 }}
            endIcon={controlGroupingApplied ? <Done /> : undefined}
            onClick={(e) => {
              if (!controlGroupingApplied) {
                setRowGrouping(controlGroup);
              } else {
                setRowGrouping([]);
              }
            }}
          >
            Control Number View
          </Button>
          {!generatingReports && selected.length > 0 && (
            <Button
              size="small"
              variant={"contained"}
              sx={{ borderRadius: 100 }}
              endIcon={<RestartAlt />}
              onClick={(e) => {
                handleGenerateReports();
              }}
            >
              Generate Reports For Selected
            </Button>
          )}
          {!approvingReports && selected.length > 0 && (
            <Button
              size="small"
              variant={"contained"}
              sx={{ borderRadius: 100, backgroundColor: "green" }}
              endIcon={<Check />}
              onClick={(e) => {
                let inspections = inspectionsWithMostRecent.filter((i: any) => {
                  return selected.indexOf(i.id) >= 0;
                });
                let hasReports = true;
                inspections.forEach((i: any) => {
                  if (!i.inspectionAssignments[0].hasReportsGenerated) {
                    hasReports = false;
                  }
                });
                if (!hasReports) {
                  setGeneratingReportsWarning(true);
                } else {
                  setApprovingReports(true);
                  approveReports({
                    variables: {
                      reportApproval: {
                        inspectionAssignmentIds: inspections.map(
                          (i: any) => i.inspectionAssignments[0].id
                        ),
                        personId: person.person.id,
                      },
                    },
                  });
                }
              }}
            >
              Approve Reports For Selected
            </Button>
          )}
          {!downloadingReports && (
            <Button
              size="small"
              variant={"contained"}
              sx={{ borderRadius: 100 }}
              endIcon={<Download />}
              onClick={(e) => {
                setDownloadingReports(true);
                var rows = gridFilteredSortedRowEntriesSelector(apiRef);
                var downloads: any = [];
                rows.forEach((r: any) => {
                  if (r.model.status === "Approved") {
                    r.model.inspectionAssignments.forEach((ia: any) => {
                      if (ia.status === "Approved") {
                        downloads.push({
                          assignmentId: ia.id,
                          address:
                            r.model.location.street1 +
                            " " +
                            r.model.location.city +
                            ", " +
                            r.model.location.state +
                            " " +
                            r.model.location.zip,
                        });
                      }
                    });
                  }
                });

                getReportResults({
                  variables: {
                    reportResult: {
                      inspectionAssignmentId: downloads.map(
                        (d: any) => d.assignmentId
                      ),
                    },
                  },
                }).then((results) => {
                  let reports: any = [];

                  results.data.reportResults.forEach((report: any) => {
                    var record = downloads.find(
                      (d: any) =>
                        d.assignmentId === report.inspectionAssignmentId
                    );
                    var address = record.address;
                    var existing = reports.find(
                      (r: any) => r.address === address
                    );
                    if (existing) {
                      var index = reports.indexOf(existing);
                      var newReport = { ...existing };
                      newReport.pdfs.push({
                        fileName: report.fileName,
                        bytes: decodeFromBase64(report.documentBytes),
                      });
                      reports[index] = newReport;
                    } else {
                      reports.push({
                        address: address,
                        pdfs: [
                          {
                            fileName: report.fileName,
                            bytes: decodeFromBase64(report.documentBytes),
                          },
                        ],
                      });
                    }
                  });
                  genPDFDownload(reports);
                  setDownloadingReports(false);
                });
              }}
            >
              Download Approved Reports
            </Button>
          )}
          {downloadingReports && (
            <Dialog open={downloadingReports} maxWidth="lg">
              <DialogTitle>Downloading Reports</DialogTitle>
              <DialogContent>
                Please do not close this browser window.
              </DialogContent>
            </Dialog>
          )}
          {generateReportsWarning && (
            <Dialog open={generateReportsWarning} onClose={() => {}}>
              <DialogTitle>Approve Reports</DialogTitle>
              <DialogContent>
                There are inspections selected that do not have reports
                generated. All reports must be generated before approval.
                Generate reports for selected inspections now?
              </DialogContent>
              <DialogActions style={{ justifyContent: "space-between" }}>
                <Button
                  variant="contained"
                  color="error"
                  onClick={() => {
                    setGeneratingReportsWarning(false);
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  color="success"
                  onClick={() => {
                    setGeneratingReportsWarning(false);
                    handleGenerateReports();
                  }}
                >
                  Confirm
                </Button>
              </DialogActions>
            </Dialog>
          )}
          {generatingReports && (
            <Dialog open={generatingReports} maxWidth="lg">
              <DialogTitle>Generating Reports</DialogTitle>
              <DialogContent>
                Please do not close this browser window.
              </DialogContent>
            </Dialog>
          )}
          {approvingReports && (
            <Dialog open={approvingReports} maxWidth="lg">
              <DialogTitle>Approving Reports</DialogTitle>
              <DialogContent>
                Please do not close this browser window.
              </DialogContent>
            </Dialog>
          )}
          {loading && <CircularProgress />}
        </Stack>
        <TextField
          size="small"
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: "100px",
            },
          }}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          label="Search Control Number . . ."
          InputProps={{
            endAdornment:
              search === "" ? (
                <InputAdornment position="end">
                  <Search />
                </InputAdornment>
              ) : (
                <div
                  onClick={(e) => setSearch("")}
                  style={{ cursor: "pointer" }}
                >
                  <InputAdornment position="end">
                    <Close />
                  </InputAdornment>
                </div>
              ),
          }}
        />
      </Stack>
      {statusValues && (
        <DataGridPremium
          apiRef={apiRef}
          pagination
          onRowGroupingModelChange={(newModel) => {
            setRowGrouping(newModel);
          }}
          getRowHeight={() => "auto"}
          slots={{ noRowsOverlay: NoRowsOverlay }}
          autoHeight
          filterModel={filters}
          onFilterModelChange={(newModel) => setFilters(newModel)}
          rowGroupingModel={rowGrouping}
          columns={[
            { ...checkboxColumn(apiRef) },
            {
              field: "edit",
              headerName: "",
              width: 10,
              renderCell: (params: any) => {
                if (params.id.includes("auto-generated")) return <></>;
                return (
                  // <Link to={`${params.number}?inspection=${params.id}`}>
                  //   <Edit />
                  // </Link>
                  <Link to={`${params.row.number}?inspection=${params.id}`}>
                    <Edit />
                  </Link>
                );
              },
            },
            {
              field: "number",
              headerName: "Control #",
            },
            {
              field: "start",
              headerName: "Start Date",
              width: 160,
              type: "date",
              valueGetter: ({ value }) => value && new Date(value),
            },
            {
              field: "end",
              headerName: "End Date",
              type: "date",
              valueGetter: ({ value }) => {
                return value && new Date(value);
              },
              width: 160,
            },
            {
              type: "string",
              field: "address",
              headerName: "Address",
              groupingValueGetter: addressValueGetter,
              valueGetter: addressValueGetter,
            },
            {
              field: "person",
              headerName: "Inspector",
              width: 140,
            },
            {
              field: "type",
              headerName: "Type",
              width: 200,
            },
            {
              field: "status",
              type: "singleSelect",
              valueOptions: statusValues.inspectionAssignmentStatusValues.map(
                (s: any) => {
                  return s.status;
                }
              ),
              headerName: "Status",
              width: 120,
            },
            {
              field: "statusDate",
              headerName: "Status Date",
              type: "date",
              valueGetter: ({ value }) => {
                console.log(value);
                return value && new Date(value);
              },
              width: 160,
            },
            {
              field: "washoutCount",
              headerName: "Open Washouts",
              width: 130,
              align: "right",
            },
            {
              field: "hasReportsGenerated",
              headerName: "Reports Generated",
              width: 150,
              type: "singleSelect",
              valueOptions: ["true", "false"],
              valueGetter: ({ value }) => (value ? value.toString() : ""),
              renderCell: (params: any) => {
                if (params.id.includes("auto-generated")) return <></>;
                return params.row.hasReportsGenerated ? (
                  <Check sx={{ color: "green" }}></Check>
                ) : (
                  <CloseOutlined sx={{ color: "red" }}></CloseOutlined>
                );
              },
            },
          ]}
          rows={rowsWithTextboxFilter}
          checkboxSelection
          onRowSelectionModelChange={handleSelection}
        />
      )}
    </>
  ) : (
    <CircularProgress />
  );
};

export const addressValueGetter = ({ row }: { row: any }) => {
  const value = row.location;
  if (!value) return null;
  const res =
    (value.street1 ? value.street1 : "") +
    (value.unit ? " " + value.unit : "") +
    (value.street2 ? " " + value.street2 : "") +
    (value.street3 ? " " + value.street3 : "") +
    ", " +
    value.city +
    ", " +
    value.state +
    ", " +
    value.zip;
  return res;
};
